import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import {
  loadTestDetail,
  clearTestDetail,
  savePublicTest,
} from '../../common/tests/actions'
import { setCurrentLesson } from '../../common/lessons/actions'
import { loadResultsByTest } from '../../common/results/actions'
import { Title, BackLink, PageHeader, GuideMessage, EmptyList, Button, ResultsAggregatedStats } from '../components'
import { LessonDetailPage } from '../pages'

class TestDetailPage extends React.Component {
  componentDidMount() {
    const { loadTestDetail, loadResultsByTest, match } = this.props
    
    loadTestDetail(match.params.id)
    loadResultsByTest(match.params.id)
  }

  componentWillUnmount() {
    this.props.clearTestDetail()
  }

  render() {
    const { currentTest, viewer, currentLesson, setCurrentLesson, results, intl, stats } = this.props

    if (!currentTest) return null

    return (
      <div>
        <Title message={`Test ${currentTest.name}`} />
        <BackLink />
        <PageHeader
          title={`${intl.formatMessage(messages.test)} ${currentTest.name}`}
        />
        <GuideMessage
          text={`${intl.formatMessage(messages.testUrl)}: vobo.io/test/${currentTest.testId}`}
        />
        <p className="test-address-mobile">
          {`${intl.formatMessage(messages.testUrl)}: vobo.io/test/${currentTest.testId}`}
        </p>
        <div className="full-width float-left spacing-bottom">
          <Link to={`/test/${currentTest.testId}`}>
            {intl.formatMessage(messages.studentView)}
          </Link>
        </div>
        <div className="width-full test-lessons-list">
          <h3>{intl.formatMessage(messages.exercises)}:</h3>
          {
            currentTest.lessons.map(l => (
              <Button
                className="blue-button"
                key={l.id}
                onClick={() => setCurrentLesson(l)}
              >
                {l.name}
              </Button>
            ))
          }
        </div>
        {
          currentLesson &&
          <div className="popup-wrapper">
            <div className="popup-content">
              <LessonDetailPage isPopup />
            </div>
          </div>
        }
        {/*
          stats ?
            <ResultsAggregatedStats stats={stats} />
          :
            <EmptyList title={intl.formatMessage(messages.noResults)} />
        */}
        <div className="float-left spacing-top">
          {
            currentTest.createdBy === viewer.id ?
              <div>
                <Link className="float-left spacing-right" to={`/app/edit-test/${currentTest.id}`}>
                  <Button className="disable-spacing-left">{intl.formatMessage(messages.edit)}</Button>
                </Link>
                <Link className="float-left" to={`/app/results/${currentTest.id}`}>
                  <Button>{intl.formatMessage(messages.results)}</Button>
                </Link>
              </div>
            :
              <Button
                positive
                onClick={() => savePublicTest(currentTest.id)}
              >
                {intl.formatMessage(messages.save)}
              </Button>
          }
        </div>
      </div>
    )
  }
}

TestDetailPage.defaultProps = {
  currentTest: null,
  currentLesson: null,
  stats: null,
  results: [],
  viewer: null,
  match: null,
}

TestDetailPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadTestDetail: PropTypes.func.isRequired,
  clearTestDetail: PropTypes.func.isRequired,
  setCurrentLesson: PropTypes.func.isRequired,
  loadResultsByTest: PropTypes.func.isRequired,
  results: PropTypes.array,
  currentTest: PropTypes.object,
  currentLesson: PropTypes.object,
  stats: PropTypes.object,
  viewer: PropTypes.object,
  match: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    currentTest: state.tests.currentTest,
    currentLesson: state.lessons.currentLesson,
    results: state.results.all,
    viewer: state.users.viewer,
    stats: state.results.stats,
  }), { clearTestDetail, loadTestDetail, setCurrentLesson, savePublicTest, loadResultsByTest }),
  injectIntl,
)

export default enhance(TestDetailPage)

const messages = defineMessages({
  test: {
    id: 'test.page.test',
    defaultMessage: 'Test',
  },
  testUrl: {
    id: 'test.page.testUrl',
    defaultMessage: 'Adresa testu',
  },
  exercises: {
    id: 'test.page.exercises',
    defaultMessage: 'Cvičenia',
  },
  results: {
    id: 'test.page.results',
    defaultMessage: 'Výsledky',
  },
  noResults: {
    id: 'test.page.noResults',
    defaultMessage: 'Zatiaľ test nebol vyplnený žiakmi',
  },
  studentView: {
    id: 'test.page.studentView',
    defaultMessage: 'Zobraziť test z pohľadu žiaka',
  },
  edit: {
    id: 'test.page.edit',
    defaultMessage: 'Upraviť',
  },
  save: {
    id: 'test.page.save',
    defaultMessage: 'Uložiť',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/TestDetailPage.js